/* The note beside a card's Save (decision 2760): it takes the rest of the actions row and wraps under the Save on a narrow card. */
.note {
  flex: 1 1 auto;
  min-width: 0;
}
